import React, { useEffect, useState } from 'react';
import { useFeira } from '../../Contexts/FeiraContext';
import '../../MeuSCSS/Banner.css';

const BannerVendas = () => {
  const { banner, bannerMobile } = useFeira();

  const getIsLandscape = () => window.matchMedia('(orientation: landscape)').matches;
  const [isLandscape, setIsLandscape] = useState(getIsLandscape());
  const [bannerSrc, setBannerSrc] = useState(banner);

  useEffect(() => {
    const mql = window.matchMedia('(orientation: landscape)');
    const onChange = () => setIsLandscape(mql.matches);
    mql.addEventListener('change', onChange);
    window.addEventListener('resize', onChange);
    return () => {
      mql.removeEventListener('change', onChange);
      window.removeEventListener('resize', onChange);
    };
  }, []);

  useEffect(() => {
    const largura = window.innerWidth;
    if (largura > 768 || isLandscape) {
      setBannerSrc(banner || bannerMobile);
    } else {
      setBannerSrc(bannerMobile || banner);
    }
  }, [banner, bannerMobile, isLandscape]);

  return (
    <div className="header-banner">
      <img src={bannerSrc} alt="Banner" />
    </div>
  );
};

export default BannerVendas;
